import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=4ad72c41&scoped=true&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad72c41",
  null
  
)

export default component.exports